module.exports = __webpack_public_path__ + "static/media/quiz-02.35aba1fe.jpg";